<template>
  <div class="wb-vehicle-tile__dealership wb-vehicle-tile__dealership--address" :class="{ '-full-width': fullWidth }">
    <wb-icon :name.attr="'trip-end'" class="hydrated" />
    <div>
      <p v-if="$slots.name" class="wb-vehicle-tile__dealership-name">
        <slot name="name"></slot>
      </p>
      <p v-if="$slots.address">
        <slot name="address"></slot>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'UiDealerAddress',
  props: {
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.wb-vehicle-tile__dealership {
  --element-bg: var(--wb-grey-95);

  &.-full-width {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
